export default {
  "create": "Create",
  "of": "of",
  "clearFilter": "Clear Filter",
  "archived": "Archived",
  "containText": "Contains text",
  "loading": "Loading...",
};
